
import React from 'react';
import Layout from '@/components/Layout/Layout';

const PrivacyPage = () => {
  return (
    <Layout>
      <div className="container mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-center mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="lead">
              Last updated: May 20, 2025
            </p>
            
            <p>
              Carolina Trophy Roofs ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed when you visit our website (www.carolinatrophyroofs.com) or use our services.
            </p>
            
            <h2 className="text-xl font-bold mt-8 mb-4">Information We Collect</h2>
            
            <h3 className="text-lg font-semibold mt-6 mb-2">Personal Information</h3>
            <p>
              We may collect personal information that you voluntarily provide to us when you:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Complete forms on our website</li>
              <li>Request a quote or estimate</li>
              <li>Contact us via email, phone, or other communication channels</li>
              <li>Subscribe to our newsletter</li>
              <li>Participate in surveys or promotions</li>
            </ul>
            
            <p>
              This information may include your name, email address, phone number, mailing address, and any other information you choose to provide.
            </p>
            
            <h3 className="text-lg font-semibold mt-6 mb-2">Automatically Collected Information</h3>
            <p>
              When you visit our website, we may automatically collect certain information about your device, including:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>Time and date of your visit</li>
              <li>Pages you view</li>
              <li>Time spent on pages</li>
              <li>Referring website addresses</li>
            </ul>
            
            <h2 className="text-xl font-bold mt-8 mb-4">How We Use Your Information</h2>
            <p>
              We use the information we collect for various purposes, including:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Providing and improving our services</li>
              <li>Responding to your inquiries and requests</li>
              <li>Processing and fulfilling your roofing service requests</li>
              <li>Sending you marketing communications (with your consent)</li>
              <li>Analyzing website usage to improve user experience</li>
              <li>Complying with legal obligations</li>
            </ul>
            
            <h2 className="text-xl font-bold mt-8 mb-4">How We Share Your Information</h2>
            <p>
              We may share your personal information with:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Service providers who perform services on our behalf</li>
              <li>Professional advisors, such as attorneys or accountants</li>
              <li>Law enforcement or government agencies when required by law</li>
              <li>Business partners with your consent</li>
            </ul>
            
            <h2 className="text-xl font-bold mt-8 mb-4">Your Rights</h2>
            <p>
              Depending on your location, you may have rights regarding your personal information, including:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Access to your personal information</li>
              <li>Correction of inaccurate information</li>
              <li>Deletion of your information</li>
              <li>Restriction or objection to processing</li>
              <li>Data portability</li>
            </ul>
            
            <p>
              To exercise these rights, please contact us using the information provided below.
            </p>
            
            <h2 className="text-xl font-bold mt-8 mb-4">Contact Us</h2>
            <p>
              If you have questions or concerns about this Privacy Policy or our data practices, please contact us at:
            </p>
            <p>
              Carolina Trophy Roofs<br />
              104 S. Business Ct<br />
              Rocky Mount, NC 27804<br />
              Email: Claims@CarolinaTrophyRoofs.com<br />
              Phone: (252) 302-2003
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPage;
